import { render, staticRenderFns } from "./PartyTicketsManagement.vue?vue&type=template&id=2ac44b62"
import script from "./PartyTicketsManagement.vue?vue&type=script&lang=js"
export * from "./PartyTicketsManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports